import { useOutletContext } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import NewDocument from 'modules/documents/components/Documents/New'
import { Folder } from 'modules/documents/hooks/useGetFolders'

const NewDocumentPage = () => {
  const { navigation } = useNavigation()
  const { employeeId, folder, initialFolder } = useOutletContext<{
    employeeId: number
    folder: Folder
    initialFolder: Folder
  }>()

  return (
    <NewDocument
      employeeId={employeeId}
      folder={initialFolder ?? folder}
      backRoute={navigation.documents.list.fullPath()}
    />
  )
}

export default NewDocumentPage
